export default {
  APP_URL: {
    url:
      'https://play.google.com/store/apps/details?id=org.intermountainhealthcare.android.connectcare'
  },
  DATE_FORMAT: {
    mmddyyyy: 'MM/DD/YYYY'
  }
};
